import PermissionFields from "components/permission/fields";
import { Localize } from "components/service";
import { TPermission } from "./permission-types-helper";

const permissionColumns = [
    {
        title: <Localize>TABLES.Column_Title_ID</Localize>,
        dataIndex: 'id',
        columnIndex: 'ID',
        sorter: true,
        width: '4%'
    },
    {
        title: <Localize>TABLES.Column_Title_Slug</Localize>,
        dataIndex: 'slug',
        columnIndex: 'SLUG',
        // sorter: true
    },
    {
        title: <Localize>TABLES.Column_Title_GroupName</Localize>,
        dataIndex: 'group_name',
        columnIndex: 'GROUP_NAME',
        sorter: true
    },
    {
        title: <Localize>TABLES.Column_Title_Action</Localize>,
        dataIndex: 'action',
        columnIndex: 'ACTION',
        sorter: true
    },
    {
        title: <Localize>TABLES.Column_Title_EntryPoint</Localize>,
        dataIndex: 'entry_point',
        columnIndex: 'ENTRY_POINT',
        sorter: true
    },
    {
        dataIndex: 'actions',
        align: 'right',
        width: '4%',
    }
];

const permissionData = (permissions: TPermission[] | undefined) =>
{
    if (!permissions) {
        return [];
    }

    return permissions.map(permission =>
    {
        return {
            key: permission.id,
            id: permission.id,
            slug: <PermissionFields.Info permission={permission} />,
            group_name: <Localize>{permission.group_name}</Localize>,
            action: <Localize>{permission.action}</Localize>,
            entry_point: <Localize>{permission.entry_point}</Localize>,
            actions: <PermissionFields.Action permissionId={permission.id} permissionName={permission.slug || `${permission.group_name}.${permission.action}`} />
        };
    });
};

const PermissionTableHelper = {
    columns: permissionColumns,
    data: permissionData,
};

export default PermissionTableHelper;